import React from 'react';
import { useBillingContext } from './billing.context';
import {
  CurrentBalance,
} from './components';


export const BillingSettingsCardsSection: React.VFC = () => {
  const {
    handlePayBalanceClick,
    handleAutopayOn,
  } = useBillingContext();

  return (
    <CurrentBalance
      onAutopayOnClick={handleAutopayOn}
      onPayBalanceClick={handlePayBalanceClick}
    />
  );
};
